App.addModule(function(app) {

    app.on('loaded', () => {

	    const template = app.get('theme.loader_template');
	    
	    $('#remove-coupon-link').on('click', function() {
		    $('#remove-coupone').val(1);
		    $('#coupon-form').trigger('submit');
	    });
	    
	    $('#shipping-country').change(function() {
		    $(this).parents('form').submit();
		    $(this).parents('.shipping')
			    .html(template)
			    .find('.loader')
				    .show();
        });
        
        $('#shipping-method').change(function() {
        	$(this).parents('form').submit();
	        $(this).parents('.shipping')
	        	.html(template)
	        	.find('.loader')
	        		.show();
        });

	    $('.form-addtocart')
		    .data('ajaxUrl', app.get('catalog.product.add_to_cart_url'))
		    .data('dataType', 'json')
		    .data('useAjax', function() {
			    return BS.isScreenSmMin();
		    })
		    .on('submitBefore.mia.form', function() {
			    
			    if (BS.isScreenSmMin()) {
				    
				    var modal = app.appendModal('cart-modal');
				    
				    modal.find('.modal-content').html(template); // reset
				    
				    modal.find('.loader').show();
				    
				    modal.modal('show');
			    }
		    })
		    .on('submitted.mia.form', function(event, ok, result) {
			    
			    if (!ok) {
				    return;
			    }
			    
			    var modal = $('#cart-modal');
			    
			    modal.find('.modal-content').html(result.html);
			    
			    modal.find('.qty').each(function() {
				    var input = $(this);
				    input.replaceWith('<span>Menge '+ input.val() +'</span>');
			    });
			    
			    $('.cart-badge').text(result.cart.items_count);
                
                for (const [id, item] of Object.entries(result.cart.items)) {

                    const qty = item.qty - app.get('checkout.cart.items.'+ item.id +'.qty', 0)
                    
			        app.set('checkout.cart.items', id, item)
				    
					if (qty > 0) {
	                    app.dispatchEvent('cart:update', [item, qty])
					}
		        }
		    });
		    
            for (const [id, qty] of Object.entries(app.get('checkout.cart.update'))) {
			    app.dispatchEvent('cart:update', [app.get('checkout.cart.items.'+ id.toString()), qty])
		    }
		    
            for (const [id, item] of Object.entries(app.get('checkout.cart.remove'))) {
                app.dispatchEvent('cart:update', [item, item.qty * -1])
		    }
    })
})
